import { render, staticRenderFns } from "./FloorsPage.vue?vue&type=template&id=78444efc&"
import script from "./FloorsPage.vue?vue&type=script&lang=js&"
export * from "./FloorsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports